import React from 'react';
import styled from 'styled-components/macro';
import { Typography } from '@deeptrue-frontend/ui';
import { useFormatMessage, useCurrency } from 'components/IntlProvider';
import { ReactComponent as TagIcon } from 'assets/icons/tag.svg';

const VoucherContainer = styled.div<{ displayFlex?: boolean; margin?: string }>`
  background: #eafbea;
  border-radius: 2px;
  padding: 1rem;
  margin: ${({ margin }) => (margin ? margin : '1rem 1.5rem 2rem')};
  display: flex;

  flex-direction: column;

  ${({ displayFlex }) =>
    displayFlex &&
    `
    align-items: center;
    justify-content: space-between;
  flex-direction: row;

  `}
`;

const Tag = styled(TagIcon)`
  margin-right: 0.5rem;
  transform: rotate(120deg);
  fill: #1c8019;
`;

const Striked = styled.span`
  text-decoration: line-through;
`;

const Price = styled.span`
  font-weight: 500;
  font-size: 1.25rem;
`;

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
`;

interface Props {
  discountPercent: number;
  projectPrice: number;
  projectPriceBeforeDiscount: number;
  displayFlex?: boolean;
  margin?: string;
}

const VoucherInfo = ({
  discountPercent,
  projectPrice,
  projectPriceBeforeDiscount,
  displayFlex,
  margin,
}: Props) => {
  const t = useFormatMessage();
  const formatCurrency = useCurrency();
  return (
    <VoucherContainer displayFlex={displayFlex} margin={margin}>
      <TextWrapper>
        <Tag />
        <Typography fontWeight="500">
          {t(
            'vouchers.appliedBase',
            'Voucher of {discount}% applied to the base fee',
            {
              discount: discountPercent,
            }
          )}
        </Typography>
      </TextWrapper>

      <Typography fontSize="0.875rem">
        {t('vouchers.newPrice', 'New project price')}{' '}
        <Striked>{formatCurrency({ value: projectPrice })}</Striked>{' '}
        <Price>{formatCurrency({ value: projectPriceBeforeDiscount })}</Price>
      </Typography>
    </VoucherContainer>
  );
};

export default VoucherInfo;
